import { render, staticRenderFns } from "./security_rounds.vue?vue&type=template&id=a4dc16ac&scoped=true"
import script from "./security_rounds.vue?vue&type=script&lang=js"
export * from "./security_rounds.vue?vue&type=script&lang=js"
import style0 from "./security_rounds.vue?vue&type=style&index=0&id=a4dc16ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dc16ac",
  null
  
)

export default component.exports